// extracted by mini-css-extract-plugin
export default {"footerDate":"styles_footerDate__RE3qt","rights":"styles_rights__RdEtg"};